import React, { useEffect, useState } from 'react'
import {
  SquareCheck,
  TrendingDown,
  DownloadIcon
} from 'lucide-react'
import styles from './KpisPDL.module.css'
import { usePDLContextData } from '../Context'
import {
  downloadPDLKpis,
  getPDLKpis,
  loggingApiPDL
} from '../../../../../services/cesl-bus/pdlService'
import { displayValue } from '../../../../Shared/common'
import { BsBusFrontFill } from 'react-icons/bs'
import { MdOutlineBusAlert } from 'react-icons/md'

const CARDS = [
  {
    label: 'Total Fleet',
    subtitle: 'matched vehicles',
    icon: BsBusFrontFill,
    key: 'total_vehicle',
    downloadApi: 'download-vehicle-ageing-pdl-total'
  },
  {
    label: 'PDL Active',
    subtitle: 'heartbeat received',
    icon: SquareCheck,
    key: 'pdl_activated',
    downloadApi: 'download-vehicle-ageing-pdl-activated'
  },
  {
    label: 'Lost PDL',
    subtitle: 'click to view list',
    icon: TrendingDown,
    key: 'lost_pdl',
    downloadApi: 'download-vehicle-ageing-pdl-lost'
  },
  {
    label: 'Critical Ageing',
    subtitle: '>30 days lost',
    icon: MdOutlineBusAlert,
    key: 'critical_ageing',
    downloadApi: 'download-vehicle-ageing-pdl-lost-critical'
  }
]

function StatCard({
  label,
  value,
  subtitle,
  icon: Icon,
  downloadApi
}) {
  const { GlobalFilter } = usePDLContextData()

  function downloadKpiData(api, name) {
    downloadPDLKpis(api, GlobalFilter)
      .then(data => {
        const url = window.URL.createObjectURL(data)

        const link = document.createElement('a')
        link.href = url
        link.download = `${name}.csv`

        document.body.appendChild(link)
        link.click()
        link.remove()

        window.URL.revokeObjectURL(url)
      })
      .catch(() => {})
  }

  return (
    <div className="col-12 col-sm-6 col-lg-3">
      <div
        className={`${styles.card} cursor-pointer`}
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={subtitle}
      >

        {/* LEFT */}
        <div className={styles.cardContent}>

          <div className={styles.labelRow}>
            <span className={styles.label}>
              {label}
            </span>

            <DownloadIcon
              onClick={() =>
                downloadKpiData(downloadApi, label)
              }
              className={`${styles.downloadIcon} custom-Btn-animation`}
              size={13}
            />
          </div>

          <div className={styles.value}>
            {displayValue(value)}
          </div>

        </div>

        {/* RIGHT */}
        <div className={styles.iconWrapper}>
          <Icon className={styles.icon} />
        </div>

      </div>
    </div>
  )
}

const initialValue = {
  total_vehicle: null,
  pdl_activated: null,
  lost_pdl: null,
  critical_ageing: null
}

export default function FleetStatsRow() {
  const { GlobalFilter } = usePDLContextData()

  const [kpiData, setKpiData] = useState(initialValue)

  useEffect(()=>{
    loggingApiPDL()
  },[])

  useEffect(() => {
    getPDLKpis(GlobalFilter)
      .then(res => {
        setKpiData(res)
      })
      .catch(() => {
        setKpiData(initialValue)
      })
  }, [GlobalFilter])

  return (
    <div className="container-fluid py-2">
      <div className="row g-2">

        {CARDS.map(card => (
          <StatCard
            key={card.label}
            value={kpiData?.[card.key]}
            {...card}
          />
        ))}

      </div>
    </div>
  )
}